import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

const STORAGE_KEY = "cd_cookie_choice"; // "accepted" | "declined"

export default function CookieBanner() {
  const { lang } = useI18n();
  const [choice, setChoice] = useState(() => {
    if (typeof window === "undefined") return "pending";
    return localStorage.getItem(STORAGE_KEY) || "pending";
  });

  useEffect(() => {
    // If user declined, opt out of PostHog analytics where available
    if (choice === "declined" && typeof window !== "undefined" && window.posthog) {
      try {
        window.posthog.opt_out_capturing();
      } catch {
        /* noop */
      }
    }
    if (choice === "accepted" && typeof window !== "undefined" && window.posthog) {
      try {
        window.posthog.opt_in_capturing();
      } catch {
        /* noop */
      }
    }
  }, [choice]);

  if (choice !== "pending") return null;

  function set(value) {
    localStorage.setItem(STORAGE_KEY, value);
    setChoice(value);
  }

  const C = COPY[lang];

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 no-print"
      style={{ background: "var(--ink)", color: "white", borderTop: "1px solid rgba(255,255,255,0.15)" }}
      data-testid="cookie-banner"
    >
      <div className="container-cd py-4 flex flex-col md:flex-row md:items-center gap-4 justify-between">
        <div className="text-sm flex-1" style={{ color: "rgba(255,255,255,0.85)" }}>
          {C.body}{" "}
          <Link to="/legal/privacy" className="underline" style={{ color: "var(--orange)" }} data-testid="cookie-banner-privacy-link">
            {C.learnMore}
          </Link>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => set("declined")}
            className="btn btn-ghost btn-sm"
            style={{ color: "white", borderColor: "rgba(255,255,255,0.4)" }}
            data-testid="cookie-banner-decline"
          >
            {C.decline}
          </button>
          <button
            onClick={() => set("accepted")}
            className="btn btn-primary btn-sm"
            data-testid="cookie-banner-accept"
          >
            {C.accept}
          </button>
        </div>
      </div>
    </div>
  );
}

const COPY = {
  en: {
    body: "We use a session cookie for sign-in, a language preference cookie, and anonymized analytics via PostHog to improve the platform.",
    learnMore: "Read our Privacy Policy.",
    accept: "Accept",
    decline: "Decline analytics",
  },
  es: {
    body: "Usamos una cookie de sesión para iniciar sesión, una cookie de preferencia de idioma y analítica anonimizada vía PostHog para mejorar la plataforma.",
    learnMore: "Lee nuestra Política de Privacidad.",
    accept: "Aceptar",
    decline: "Rechazar analítica",
  },
};
